// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css-new/" + (chunkId === 918 ? "Account" : chunkId) + "-" + {"466":"67bdc3","918":"200886"}[chunkId] + ".css";
};